export default function LocationPinSimple(
	props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
	return (
		<svg
			width="14"
			height="18"
			viewBox="0 0 14 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M6.99479 9.00008C7.45312 9.00008 7.84549 8.83689 8.17187 8.5105C8.49826 8.18411 8.66146 7.79175 8.66146 7.33341C8.66146 6.87508 8.49826 6.48272 8.17187 6.15633C7.84549 5.82994 7.45312 5.66675 6.99479 5.66675C6.53646 5.66675 6.1441 5.82994 5.81771 6.15633C5.49132 6.48272 5.32812 6.87508 5.32812 7.33341C5.32812 7.79175 5.49132 8.18411 5.81771 8.5105C6.1441 8.83689 6.53646 9.00008 6.99479 9.00008ZM6.99479 15.1251C8.68924 13.5695 9.94618 12.1563 10.7656 10.8855C11.5851 9.61466 11.9948 8.48619 11.9948 7.50008C11.9948 5.98619 11.5122 4.74661 10.5469 3.78133C9.5816 2.81605 8.39757 2.33341 6.99479 2.33341C5.59201 2.33341 4.40799 2.81605 3.44271 3.78133C2.47743 4.74661 1.99479 5.98619 1.99479 7.50008C1.99479 8.48619 2.40451 9.61466 3.22396 10.8855C4.0434 12.1563 5.30035 13.5695 6.99479 15.1251ZM6.99479 17.3334C4.75868 15.4306 3.08854 13.6633 1.98437 12.0313C0.880208 10.3994 0.328125 8.88897 0.328125 7.50008C0.328125 5.41675 0.998264 3.75703 2.33854 2.52091C3.67882 1.2848 5.2309 0.666748 6.99479 0.666748C8.75868 0.666748 10.3108 1.2848 11.651 2.52091C12.9913 3.75703 13.6615 5.41675 13.6615 7.50008C13.6615 8.88897 13.1094 10.3994 12.0052 12.0313C10.901 13.6633 9.2309 15.4306 6.99479 17.3334Z"
				fill="currentColor"
			/>
		</svg>
	)
}
